<template>
  <v-container grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-flex md8 offset-md2>
        <v-card>
          <v-toolbar flat color="grey lighten-3">
            <v-btn icon @click="close()">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>{{ action.actionName }} - Notifications</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon v-if="this.loggedInUser.securityMask.charAt(parseInt(this.access['NotificationAdd'])-1) == '1'" @click="addNotification()">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap="" v-if="notifications.length === 0">
              <v-flex xs12 class="text-xs-center">
                <p>No notifications are available.</p>
              </v-flex>
            </v-layout>
            <v-list two-line>
              <template v-for="(item, index) in notifications">
                <v-list-tile
                  :key="item.NotificationID"
                  @click="editNotification(item.NotificationID)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.actionName"></v-list-tile-title>
                    <v-list-tile-title v-html="item.notificationTypeLabel"></v-list-tile-title>
                    <v-list-tile-sub-title>{{ item.lastName.toUpperCase() }}, {{ item.firstName.toUpperCase() }}</v-list-tile-sub-title>
                    <v-divider :key="index"></v-divider>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider :key="index"></v-divider>
              </template>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import RestService from '../services/RestService';
import * as Sentry from '@sentry/browser';

const service = new RestService();

export default {
  name: 'Notifications',
  props: {
    userId: String,
    actionId: String
  },
  data() {
    return {
      loggedInUser: {},
      access: {},
      notifications: [],
      action: {}
    };
  },
  methods: {
    close() {
      this.$router.go(-1);
    },
    addNotification() {
      this.$router.push(
        '/user/' +
          this.userId +
          '/action/' +
          this.actionId +
          '/notification/add'
      );
    },
    editNotification(notificationId) {
      this.$router.push(
        '/user/' +
          this.userId +
          '/action/' +
          this.actionId +
          '/notification/' +
          notificationId
      );
    }
  },
  created() {
    this.loggedInUser = this.$store.getters['auth/user'];
    this.access = this.$store.getters['auth/access'];
    service
      .getAction(this.actionId)
      .then(response => {
        this.action = response.data.body[0];
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
    service
      .getNotificationsByActionId(this.actionId)
      .then(response => {
        this.notifications = response.data.body;
      })
      .catch(e => {
        console.log(e);
        Sentry.captureException(e);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
